var map = {
	"./All-Nations.jpg": "57TE",
	"./Bells-Hotel.jpg": "anYK",
	"./Clyde-Hotel.jpg": "f4Nm",
	"./College-Lawn.jpg": "6iHE",
	"./Corner-Hotel.jpg": "2CXT",
	"./Glenferrie-Hotel.jpg": "gL4u",
	"./Great-Northern.jpg": "M23O",
	"./Harp-of-Erin.jpg": "vRS3",
	"./Hotel-Brighton.jpg": "C2H7",
	"./Hotel-Railway-Brunswick.jpg": "JRt1",
	"./London-Tavern.jpg": "iO5m",
	"./Middle-Park.jpg": "6Brk",
	"./Mount-View.jpg": "tYV3",
	"./North-Fitzroy-Arms.jpg": "HDo8",
	"./PubName.jpg": "2v+C",
	"./Railway-Hotel-Yarraville.jpg": "u/zF",
	"./Rising-Sun.jpg": "AJhm",
	"./Royal-Derby.jpg": "CVcf",
	"./Royal-Standard.jpg": "Cvae",
	"./Sporting-Globe-Richmond.jpg": "52jU",
	"./Spread-Eagle.jpg": "kjEd",
	"./Terminus-Hotel.jpg": "tvMA",
	"./The-Imperial.jpg": "xYyT",
	"./The-Precinct.jpg": "XEP2",
	"./The-Rose.jpg": "IYX9",
	"./The-Vic.jpg": "fxfO",
	"./The-Victoria-Hotel.jpg": "la81",
	"./Turf-Bar.jpg": "LcMU",
	"./header.jpg": "Y5I1",
	"./undefined.jpg": "7i7r",
	"./x-x.jpg": "p5P7"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "53WL";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/.*\.jpg$
// module id = 53WL
// module chunks = 0